module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACwAAAAmCAMAAACIwYlVAAAAAXNSR0IArs4c6QAAAGBQTFRFAAAAAID/KoD/JJL/IID/HI7/GoD/G4b/FIX/GYn5GIz5F4j5GYr7GIr7GIf7Gon7Gor7GIj5Gor6Gor6GIn7GIn7Gon5GIn6GYn5GYn6GYr6GYn6GYn6GYn6GYn6GYn6avvgzgAAAB90Uk5TAAIGBwgJChMZKSotPT9ARUZWYm19f4CouMTK2e3v/TPu26UAAACFSURBVDjL7ZTBEoIwDESDVkFbC1ZpoYj9/7+kLM4I04M5MJ76TpvNO2ZClFD4EPEFcSgDKLP8R/nytNY+BE/ukO88uUc2Wd5Hlq9YvVuebND1Wc5yIjfoHPJxnPN4wOCwqLd3KbXW6vMeqlukWrJQcSG/3unK4gx5CCwGyIHJ6kP9pCOaAGVqR2dKw92IAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/sj01@2x.png
// module id = ZxjU
// module chunks = 1